import React from 'react';
import { useFieldValue } from 'Shared/utils/hooks';
import { isFullName } from 'Shared/helpers';

function SalesAssistantInstructions() {
  const fullName = useFieldValue('profile.fullName') || '';
  const { value: roleValue } = useFieldValue('profile.role');
  const showComponent = roleValue && isFullName(fullName);

  if (!showComponent) return null;

  return (
    <div className="d-flex flex-column rounded border onboarding-mas-info-card">
      <p className="m-0 p-2">
        You have been invited to the WorkPatterns Sales Assistant, a tool which identifies CRM data quality issues, e.g.
        a close date in the past, and lets you resolve them with a few clicks.
        <br />
        To view all of your data quality issues, click the Sales Assistant button on the sidebar:
        <img
          alt="Sales Assistant Intro p1"
          src="https://piprodperformassets.blob.core.windows.net/assets/sales_assistant_intro_1.png"
          className="ml-2 img-fluid"
        />
        <br />
        Each issue will have text that describes the issue and buttons that let you resolve it:
        <img
          alt="Sales Assistant Intro p1"
          src="https://piprodperformassets.blob.core.windows.net/assets/sales_assistant_intro_2.png"
          className="img-fluid"
        />
        <br />
        <br />
        To view your issues and start resolving them, click the <b>Finish</b> button below.
      </p>
    </div>
  );
}

export default SalesAssistantInstructions;
